module.exports = __webpack_public_path__ + "images/feature/file-multi-version-1-1e9a8ac4b64c1a4dab434bd5be798adf.jpg";